import React, { ReactElement } from 'react'
import { useDispatch } from 'react-redux'
import { Flex } from '@theme-ui/components'
import platform from 'platform'
import { useAppSelector } from 'store/hooks'
import { PaymentMethod, setPaymentMethod } from 'store/billing'
import PaymentMethodButton from 'components/Plans/Payments/PaymentMethodButton'

const PaymentMethodButtonGroup = (): ReactElement => {
  const paymentMethod = useAppSelector(s => s.payments.paymentMethod)
  const xPayPaymentMethod = useAppSelector(s => s.payments.xPayPaymentMethod)
  const dispatch = useDispatch()
  const isChrome = platform.name?.includes('Chrome')
  const isGooglePay =
    (isChrome && xPayPaymentMethod === PaymentMethod.BROWSER) ||
    xPayPaymentMethod === PaymentMethod.GOOGLE
  const isBrowserPay = !isChrome && xPayPaymentMethod === PaymentMethod.BROWSER

  const isApplePay = xPayPaymentMethod === PaymentMethod.APPLE
  return (
    <Flex
      sx={{
        width: '100%',
        flex: 1,
        flexDirection: ['column', 'column', 'row'],
        flexWrap: 'wrap',
        gap: '1.6rem',
      }}
    >
      <PaymentMethodButton
        data-testid="credit-option"
        ariaLabel="Credit Card"
        onClick={(): void => {
          dispatch(setPaymentMethod(PaymentMethod.CREDIT))
        }}
        isSelected={paymentMethod === PaymentMethod.CREDIT}
      >
        Credit Card
      </PaymentMethodButton>
      <PaymentMethodButton
        data-testid="crypto-option"
        ariaLabel="Crypto"
        onClick={(): void => {
          dispatch(setPaymentMethod(PaymentMethod.CRYPTO))
        }}
        isSelected={paymentMethod === PaymentMethod.CRYPTO}
      >
        Crypto
      </PaymentMethodButton>
      {isApplePay && (
        <PaymentMethodButton
          data-testid="payment-option"
          ariaLabel="Apple Pay"
          onClick={(): void => {
            dispatch(setPaymentMethod(PaymentMethod.APPLE))
          }}
          isSelected={paymentMethod === PaymentMethod.APPLE}
        >
          Apple Pay
        </PaymentMethodButton>
      )}
      {isGooglePay && (
        <PaymentMethodButton
          data-testid="payment-option"
          ariaLabel="Google Pay"
          onClick={(): void => {
            dispatch(setPaymentMethod(PaymentMethod.GOOGLE))
          }}
          isSelected={paymentMethod === PaymentMethod.GOOGLE}
          sxButton={{
            fontWeight: paymentMethod === PaymentMethod.GOOGLE && 'bold',
          }}
        >
          Google Pay
        </PaymentMethodButton>
      )}
      {/*
      // We do not do Amazon Pay    
      {isAmazonPay && (
        <PaymentMethodButton
          data-testid="payment-option"
          onClick={(): void =>{
          dispatch(setPaymentMethod(PaymentMethod.AMAZON))}}
          isSelected={paymentMethod === PaymentMethod.AMAZON}
          icon={AmazonIcon}
          sxButton={{
            flex: isMobileOrTablet && '0 0 100%',
            mt: '2.4rem',
          }}
        >
          Pay
        </PaymentMethodButton>
      ))}} */}
      {isBrowserPay && (
        <PaymentMethodButton
          data-testid="payment-option"
          ariaLabel="browser pay"
          onClick={(): void => {
            dispatch(setPaymentMethod(PaymentMethod.BROWSER))
          }}
          isSelected={paymentMethod === PaymentMethod.BROWSER}
          sxButton={{
            flex: ['0 0 100%', '0 0 100%', '0 1 auto'],
          }}
        >
          {platform.name} pay
        </PaymentMethodButton>
      )}
    </Flex>
  )
}

export default React.memo(PaymentMethodButtonGroup)
